import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsPDFPreview } from '@backrs_ui/common-ui/src/atoms/BackrsPDFPreview';
import { formatDateToLocaleString } from '@backrs_ui/common-ui/src/utils/dateTime.util';
import { Typography, Box } from '@mui/material';
var NUGGET_STRINGS = appStrings.modules.nugget;
export var NuggetOpportunity = function (_a) {
    var variant = _a.variant;
    var _b = useState(false), isLargePDFError = _b[0], setIsLargePDFError = _b[1];
    var parsedDate = formatDateToLocaleString(variant.deadline);
    if (variant.type === 'SMALL') {
        return variant.deadline ? (_jsxs(Typography, { variant: "body1", sx: bottomTextStyle, children: [_jsx(Typography, { fontWeight: "bold", mr: 0.5, children: NUGGET_STRINGS.opportunitySubtext }), parsedDate] })) : (_jsx(_Fragment, {}));
    }
    return (_jsxs(Box, { children: [variant.deadline && (_jsxs(Typography, { variant: "body1", sx: bottomTextStyle, children: [_jsx(Typography, { fontWeight: "bold", mr: 0.5, children: NUGGET_STRINGS.opportunitySubtext }), parsedDate] })), variant.mediaUrl && !isLargePDFError ? (_jsx(BackrsPDFPreview, { documentUrl: variant.mediaUrl, onError: function () { return setIsLargePDFError(true); } })) : null] }));
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '20px',
    flexDirection: 'row',
    display: 'flex',
    mt: 3,
};
